/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Record_RepsInputs */

const en_us2_workout_live_record_reps = /** @type {(inputs: Workout_Live_Record_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most reps in a set`)
};

const pt_br2_workout_live_record_reps = /** @type {(inputs: Workout_Live_Record_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais repetições numa série`)
};

const es_419_workout_live_record_reps = /** @type {(inputs: Workout_Live_Record_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más repeticiones en una serie`)
};

const pt_pt2_workout_live_record_reps = /** @type {(inputs: Workout_Live_Record_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais repetições numa série`)
};

const fr_fr2_workout_live_record_reps = /** @type {(inputs: Workout_Live_Record_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de répétitions en une série`)
};

const de_de2_workout_live_record_reps = /** @type {(inputs: Workout_Live_Record_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meiste Wdh. in einem Satz`)
};

const it_it2_workout_live_record_reps = /** @type {(inputs: Workout_Live_Record_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più ripetizioni in una serie`)
};

/**
* | output |
* | --- |
* | "Most reps in a set" |
*
* @param {Workout_Live_Record_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_reps = /** @type {((inputs?: Workout_Live_Record_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_reps(inputs)
	if (locale === "es-419") return es_419_workout_live_record_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_reps(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_reps(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_reps(inputs)
	return en_us2_workout_live_record_reps(inputs)
});
export { workout_live_record_reps as "workout-live.record_reps" }